import { TransformDate } from '../../../decorators/transform-date.decorator';
import { TransformInt } from '../../../decorators/transform-int.decorator';
import { IdentityDocumentTypeEnum } from '../../../enums/identity-document-type.enum';
import { CountryDto } from '../../settings/dtos/country.dto';

import { BaseDriverDrivingLicenseDto } from './base-driver-driving-license.dto';

export abstract class BaseDriverDto {
  @TransformInt()
  id?: number;
  identityDocumentType?: IdentityDocumentTypeEnum | null;
  identityDocumentNumber?: string | null;
  @TransformDate()
  identityDocumentIssueDate?: Date | null;
  @TransformDate()
  identityDocumentExpiryDate?: Date | null;
  @TransformInt()
  identityDocumentIssuedByCountryId?: number | null;
  identityDocumentIssuedByCountry?: CountryDto | null;
  drivingLicenses?: BaseDriverDrivingLicenseDto[] | null;
  drivingLicenseNumber?: string | null;
  drivingLicenseCategory?: string | null;
  @TransformDate()
  drivingLicenseIssueDate?: Date | null;
  @TransformDate()
  drivingLicenseExpiryDate?: Date | null;
  @TransformInt()
  drivingLicenseIssuedByCountryId?: number | null;
  drivingLicenseIssuedByCountry?: CountryDto | null;
}
